module.exports = __webpack_public_path__ + "static/media/proj20_img7.9479498a.jpg";